import { defineNuxtPlugin } from '#app'
import VueMatomo from 'vue-matomo'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(VueMatomo, {
        host: 'https://analytics.datenbankgestalter.de',
        siteId: nuxtApp.$config.public.analyticsId,
        // Enables automatically registering pageviews on the router
        router: nuxtApp.$router,
        enableLinkTracking: true,
        requireConsent: false,
        trackInitialView: true,
        disableCookies: true,
        requireCookieConsent: false,
    })
})
